var Player = function () {};

Player.prototype = {
  init: function (audio) {
    var self = this;
    var sound = (self.howl = new Howl({
      src: [audio],
      html5: true,
      onplay: function () {
        duration.innerHTML = self.formatTime(Math.round(sound.duration()));
        requestAnimationFrame(self.step.bind(self));
        // waveform.style.display = "block";
        pauseBtn.style.display = "block";
      },
      onload: function () {
        // waveform.style.display = "block";
        loading.style.display = "none";
      },
      onend: function () {
        // waveform.style.display = "none";
      },
      onpause: function () {
        // waveform.style.display = "none";
      },
      onstop: function () {
        // waveform.style.display = "none";
      },
      onseek: function () {
        // cancelAnimationFrame(self.step.bind(self));
        // self.play();
        requestAnimationFrame(self.step.bind(self));
      }
    }));
  },
  destroy: function () {
    var sound = this.howl;
    if (!sound) return;

    sound.pause();
    sound.seek(0);

    sound = null;
    window.sliderDown = false;

    playBtn.style.display = "block";
    pauseBtn.style.display = "none";
  },
  play: function () {
    var sound = this.howl;
    if (!sound) return;
    if (!sound.playing()) {
      // return;
      sound.play();
    }

    if (sound.state() === "loaded") {
      playBtn.style.display = "none";
      pauseBtn.style.display = "block";
    } else {
      loading.style.display = "block";
      playBtn.style.display = "none";
      pauseBtn.style.display = "none";
    }
  },
  pause: function () {
    var sound = this.howl;
    if (!sound) return;
    if (sound.playing()) {
      sound.pause();
    }

    playBtn.style.display = "block";
    pauseBtn.style.display = "none";
  },
  seek: function (per) {
    var sound = this.howl;
    if (!sound) return;
    if (sound._sounds.length > 1) {
      console.log("sound");
      console.log(sound);
      sound._sounds.splice(1, sound._sounds.length);
    }
    sound.seek(sound.duration() * per);
  },

  step: function () {
    var sound = this.howl;
    if (!sound) return;
    var seek = sound.seek() || 0;
    timer.innerHTML = this.formatTime(Math.round(seek));
    progress.style.width = ((seek / sound.duration()) * 100 || 0) + "%";
    if (sound.playing()) {
      requestAnimationFrame(this.step.bind(this));
    }
  },

  formatTime: function (secs) {
    var minutes = Math.floor(secs / 60) || 0;
    var seconds = secs - minutes * 60 || 0;

    return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
  }
};

var playerElms = [
  "track",
  "timer",
  "duration",
  "playBtn",
  "pauseBtn",
  "volumeBtn",
  "progressWrap",
  "progress",
  "progressHandler",
  "bar",
  "wave",
  "waveform",
  "loading",
  "volume",
  "barEmpty",
  "barFull",
  "sliderBtn"
];
playerElms.forEach(function (elm) {
  window[elm] = document.getElementById(elm);
});

playBtn.addEventListener("click", function () {
  player.play();
});
pauseBtn.addEventListener("click", function () {
  player.pause();
});
// waveform.addEventListener("click", function (event) {
// const width = $(waveform).innerWidth();
// player.seek(event.layerX / width);
// });
waveform.addEventListener("mousedown", function (event) {
  const width = $(waveform).innerWidth();
  player.pause();
  player.seek(event.layerX / width);
  window.sliderDown = true;
});
waveform.addEventListener("touchstart", function () {
  window.sliderDown = true;
});
waveform.addEventListener("mouseup", function () {
  window.sliderDown = false;
  player.play();
});
waveform.addEventListener("touchend", function () {
  window.sliderDown = false;
});
waveform.addEventListener("mouseout", function () {
  window.sliderDown = false;
});
progressWrap.addEventListener("mousedown", function () {
  window.sliderDown = true;
});
progressWrap.addEventListener("touchstart", function () {
  window.sliderDown = true;
});
progressWrap.addEventListener("mouseup", function () {
  window.sliderDown = false;
});
progressWrap.addEventListener("touchend", function () {
  window.sliderDown = false;
});

var popup = $(".listen__popup").first();

var move = function (event) {
  event.preventDefault();
  if (window.sliderDown) {
    var target = $(event.target);

    var width = $(waveform).innerWidth();
    var x = 0;
    var eType = event.type;

    if (eType === "touchmove") {
      var parentPosition = popup.position().left + 20;
      x = event.touches[0].clientX - parentPosition;
      player.seek(x / width);
    } else if (eType === "mousemove" && target.attr("id") === "waveform") {
      x = event.layerX;
      player.seek(x / width);
    }
  }
};

// progressWrap.addEventListener("mousemove", move);
// progressWrap.addEventListener("touchmove", move);
waveform.addEventListener("mousemove", move);
waveform.addEventListener("touchmove", move);

var player = new Player();

$(function () {
  if ($().matchHeight) {
    $(".lessons__item .lessons__item__caption").matchHeight();
    $(".lessons__item .lessons__item__descr").matchHeight();
    $(".subsc-list .subsc-list__title").matchHeight();
  }

  var closePopupHandler = null;
  var overlayClickHandler = null;

  $(".read-btn").on("click", function (e) {
    e.preventDefault();
    var target = $(e.target);
    var id = target.data("popup");

    var $popup = $(id);
    var $popupTextEl = $popup.find(".popup__content__book-text");
    var $popupPreloaderEl = $popup.find(".loader");
    var bookSrc = target.data("book");

    var parentEl = target.parents(".lessons__item");
    var title = parentEl.find(".lessons__item__caption");
    $popup.find(".popup__content__caption").text(title.text());

    // $popupTextEl.text("");
    // $popupPreloaderEl.show();

    // $.ajax({
    //   type: "GET",
    //   url: bookSrc,
    //   dataType: "json",
    //   cache: false,
    //   success: function (data) {
    //     var text = data.success.text;
    //     $popupTextEl.append(text);
    //     $popupPreloaderEl.hide();
    //   },
    // });

    showPopup(id);
  });

  $(".listen-btn").on("click", function (e) {
    e.preventDefault();
    var target = $(e.target);
    var id = target.data("popup");

    var parentEl = target.parents(".lessons__item");
    var descr = parentEl.find(".lessons__item__descr");
    var title = parentEl.find(".lessons__item__caption");
    var $popup = $(id);
    $popup.find(".popup__content__text").text(descr.text());
    $popup.find(".popup__content__caption").text(title.text());

    var audioSrc = target.data("audio");

    player.init(audioSrc);

    showPopup(id);

    var popupEl = document.querySelector(id + " .popup__close");

    var listener = function (e) {
      var target = $(e.target);
      if (
        target.hasClass("popup__overlay") ||
        target.hasClass("popup__close") ||
        target.hasClass("icon-cross")
      ) {
        player.destroy();
      }
    };

    if (closePopupHandler) {
      popupEl.removeEventListener("click", listener);
      window.removeEventListener("click", listener);
    }

    closePopupHandler = popupEl.addEventListener("click", listener);
    overlayClickHandler = window.addEventListener("click", listener);
  });
});
